<template>
    <div class="TelVerification mx-auto my-2">
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <div class="my-2">
            <p>請輸入電話資料完成註冊</p>
        </div>
            <!-- 帳號/密碼  -->
        <div class="TelVerificationForm Form">
        <TelVerificationCheck 
            :telVerList="telVerList" @update:telVerList="handletelVerListChange"
            >
        </TelVerificationCheck>
        </div>
        <PrivacyPolicy @update:agree="handleAgree"></PrivacyPolicy>
        <div class="my-3">
            <div class="btn TelVerBtn" @click="BeforeCheck()">送出</div>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import TelVerificationCheck from '@/components/LineComponents/TelVerificationCheck'
import PrivacyPolicy from '@/components/LineComponents/PrivacyPolicy'

import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'

export default {
    name: 'TelVerification',
    components:{
        Nav,TelVerificationCheck,PrivacyPolicy
    },
    data () {
        return {
            Token:'',
            telVerList:{
                phone:'',
                TelCkeck:'',
                VerificationCode:''
            },
            agreePolicy:false,
            userId:'',
            showLoading:'',
        }
    },
    methods:{
        handleAgree(type){
            this.agreePolicy = type;
        },
        handletelVerListChange(newList){
            this.telVerList = newList;
            // console.log('newList',newList)
        },
        BeforeCheck(){
            if(!this.agreePolicy){ //沒有同意隱私權政策
                alert('請先同意隱私權政策');
            }else if(!this.telVerList.TelCkeck){ //電話驗證碼錯誤
                alert('驗證碼錯誤');
            }else{ //可送出
            this.CheckVerification();
            }
        },
        //驗證 驗證碼
        CheckVerification(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Member/CheckVerification`;
            const inputdata = 
            {
                "Phone":this.telVerList.phone,
                "ContactType":1,
                "VerificationCode":parseFloat(this.telVerList.VerificationCode),
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){ 
                        //驗證成功
                        this.UpdateUserPhone()
                    }else{
                        //驗證失敗
                        console.error(response.data.message);
                        alert(response.data.message);
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        UpdateUserPhone(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Member/UpdateUserPhone`;
            const inputdata = 
            {
                "Phone":this.telVerList.phone,
                "userId":this.userId,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){ 
                        //更新成功
                        this.$router.push({
                            name: 'FinishRegister',
                        });
                    }else{
                        //更新失敗
                        console.error(response.data.message);
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        }
    },
    created(){
        this.userId=JSON.parse(sessionStorage.getItem('UserData')).userId;
    },
}
</script>




// WEBPACK FOOTER //
// src/components/line/TelVerification.vue